import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Link,
    Stack,
    Typography,
} from "@mui/material";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { useSettings } from "Context/Settings/useSettings";

const Support = () => {
    const settings = useSettings()

    const supportUsers = [
        {
        //     name: "Soporte Técnico",
        //     tel: "+503 7028 6380",
        //     email: "tickets@thetecwave.com"
        // }, {
            name: "Jorge Pernillo",
            tel: "+503 7179 6559",
            email: "itsap@thetecwave.com"
        }, {
            name: "Benjamin Molina",
            tel: "+503 7028 2757",
            email: "bmolina@thetecwave.com"
        // }, {
        //     name: "Carlos Maida",
        //     tel: "+503 6993 6762",
        //     email: "carlos@thetecwave.com"
        }
    ]

    const handleClose = () => { 
        settings.setOpenSupport(false)
    }
    
    return (
        <Dialog onClose={handleClose} open={settings.openSupport} fullWidth maxWidth="md">
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}>
                <SupportAgentIcon color="primary" />
                Opciones para contactar a soporte técnico
            </DialogTitle>

            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Si necesitas ayuda o tienes alguna consulta, nuestro equipo está disponible para asistirte.
                    Puedes comunicarte por WhatsApp, teléfono, correo o crear un ticket de soporte.
                </Typography>

                <Stack spacing={1.5} sx={{ maxHeight: 320, overflowY: "auto", pr: 0.5 }}>
                    {supportUsers.map((user) => {
                        const whatsappUrl = `https://wa.me/${user.tel.replace(/\D/g, '')}`
                        return (
                            <Card key={user.name} variant="outlined" sx={{ borderRadius: 2, minHeight: 150 }}>
                                <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.2, height: "100%", justifyContent: "space-between" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                            {user.name}
                                        </Typography>
                                        <Chip size="small" label="Disponible" color="success" variant="outlined" />
                                    </Box>

                                    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                            <PhoneIcon fontSize="small" color="action" />
                                            <Typography variant="body2">{user.tel}</Typography>
                                        </Box>

                                        {user.email && (
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                                <EmailIcon fontSize="small" color="action" />
                                                <Typography variant="body2">{user.email}</Typography>
                                            </Box>
                                        )}
                                    </Stack>

                                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            startIcon={<WhatsAppIcon />}
                                            component="a"
                                            href={whatsappUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            WhatsApp
                                        </Button>

                                        {user.email && (
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                startIcon={<EmailIcon />}
                                                component="a"
                                                href={`mailto:${user.email}`}
                                            >
                                                Correo
                                            </Button>
                                        )}
                                    </Stack>
                                </CardContent>
                            </Card>
                        )
                    })}
                </Stack>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
                        <ConfirmationNumberIcon fontSize="small" color="primary" />
                        También puedes crear un ticket de soporte
                    </Typography>

                    <Link href="https://support.thetecwave.com/" target="_blank" rel="noopener noreferrer" underline="hover">
                        Crear ticket de soporte
                    </Link>

                    <Typography variant="body2" color="text.secondary">
                        Horario de atención: lunes a viernes de 9:00 a 18:00 horas.
                        Fuera de este horario, responderemos el siguiente día hábil.
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 1.5 }}>
                <Button onClick={handleClose} variant="contained">
                    Entendido
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default Support;